export default __webpack_public_path__ + "static/bc_en_3-22d012aed61f4f073aed06bee14f8aa0.mp4";